import './_tabs';
import './_dialog';

var buildPaginatorEventListener = function () {
    var paginator = $('#paginator');
    var form = $('#paginator-form');

    paginator.click(function (e) {
        $.ajax({
            type: 'post',
            url: paginator.data('url'),
            data: form.serialize(),
            dataType: 'json',
            cache: false,
            beforeSend: function () {
                paginator.prop('disabled', true);
            },
            success: function (data) {
                $('.agent-house-list').append(data.html);

                if (data.current_page < data.last_page) {
                    paginator.prop('disabled', false);
                    form.find('[name="page"]').val(data.current_page + 1);
                } else {
                    paginator.hide();
                }
            },
            error: function (jqxhr) {
                swal2.close();
                swal({
                    icon: 'error',
                    title: 'server error',
                }).then(function () {
                    paginator.prop('disabled', false);
                });
            }
        });
    });
};

$(document).ready(function () {
    buildPaginatorEventListener();
});

var lastScrollBarPos = 0;

$(window).on('scroll', function (event) {
    var win_H = $(window).outerHeight(true);
    var doc_H = $(document).outerHeight(true);
    var distance = $(this).scrollTop();
    var win_w = $(window).outerWidth(true);
    var top;
    if (win_w <= 768) {
        top = distance + win_H - 600;
    } else {
        top = distance + win_H - 700;
    }

    var blockLength = $('[data-anchor-block="true"]').length;
    if (top >= $('[data-anchor-block="true"]').eq(blockLength - 1).position().top) {
        $('[data-anchor-btn="true"]').eq(blockLength - 1).addClass('current').siblings('li').removeClass('current');
    } else if (top >= $('[data-anchor-block="true"]').eq(blockLength - 2).position().top) {
        $('[data-anchor-btn="true"]').eq(blockLength - 2).addClass('current').siblings('li').removeClass('current');
    } else if (top >= $('[data-anchor-block="true"]').eq(blockLength - 3).position().top) {
        $('[data-anchor-btn="true"]').eq(blockLength - 3).addClass('current').siblings('li').removeClass('current');
    } else if (top >= $('[data-anchor-block="true"]').eq(blockLength - 4).position().top) {
        $('[data-anchor-btn="true"]').eq(blockLength - 4).addClass('current').siblings('li').removeClass('current');
    }
    if (distance > lastScrollBarPos) {
        $('[data-id="anchor"]').removeClass('fixed');
    } else {
        // upscroll
        $('[data-id="anchor"]').addClass('fixed');
        if (distance <= 53) {
            $('[data-id="anchor"]').removeClass('fixed');
        }
    }

    var obj_H = $('.show').outerHeight(true),
        obj_offsetTop = $('.show').offset().top;
    if (distance >= (obj_offsetTop + obj_H - 700)) {
        $('.quickLink').addClass('unFixed');
        // $('.dockingContact').fadeOut();
    } else {
        $('.quickLink').removeClass('unFixed');
        // $('.dockingContact').fadeIn();
    }

    lastScrollBarPos = distance;
});

$(function () {
    $('[data-tab="true"]').tabs();

    $('[data-anchor-btn="true"]').on('click touched', function () {
        var anchor_target = $(this).data("anchor"),
            navHeight = $('header.header').outerHeight(true),
            anchrarbarHeight = $('[data-id="anchor"]').outerHeight(true);
        console.log(anchor_target)
        $('html,body').animate({scrollTop: $('[data-anchor-id="' + anchor_target + '"]').offset().top - navHeight - anchrarbarHeight}, 800);
        return false;
    });

    var $patternSlider = $('[data-slick-slider="pattern"]');
    $patternSlider.on('init', function (event, slick) {
        $(this).closest('.carousel').css({'visibility': 'visible'});
    }).slick({
        infinite: true,
        rows: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: true,
        arrows: false,
        dotsClass: 'slides__dots slides__dots--bottom'
    });

    var $forSlider = $('[data-slick-slider="slides-for"]');
    $forSlider.on('init', function (event, slick) {
        $(this).closest('.carousel').css({'visibility': 'visible'});
    }).slick({
        lazyLoad: 'ondemand',
        infinite: true,
        rows: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: false,
        arrows: false,
        asNavFor: '[data-slick-slider="slides-nav"]'
    });

    var $navSlider = $('[data-slick-slider="slides-nav"]');
    $navSlider.on('init', function (event, slick) {
        $(this).closest('.carousel').css({'visibility': 'visible'});
    }).slick({
        lazyLoad: 'progressive',
        infinite: true,
        rows: 0,
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '[data-slick-slider="slides-for"]',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        autoplay: false,
        rrows: true,
        prevArrow: '<button class="slick-prev slides__navArrow slides__navArrow--prev" aria-label="Previous" type="button"></button>',
        nextArrow: '<button class="slick-next slides__navArrow slides__navArrow--next" aria-label="Next" type="button"></button>'
    });

    var winW = $(window).outerWidth(true);
    if (winW <= 768) {
        $('.convert').on('click', function () {
            var hasClass = $('.convert').hasClass('active');
            if (hasClass) {
                $('.convert').removeClass('active');
            } else {
                $('.convert').addClass('active');
            }
        });
    }

    $(window).on('resize', function () {
        var wrap_width = $('.pages__object > .wrap').width();
        $('.dockingContact').css({
            right: ((winW - wrap_width) / 2 / 2) + 'px'
        })
    }).trigger('resize');
});

$(function () {
    var exportPDF = $(".sidebar__btn--pdf a");
    var buildingFeatures = $('body .trait #buildingFeatures');
    var originBuildingFeaturesHtml = buildingFeatures.html();

    exportPDF.click(function (event) {
        event.preventDefault();

        exportPDF.css('pointer-events', 'none');

        $('body .social').hide();

        var newBuildingFeaturesHtml = '';

        buildingFeatures.find('li').each(function () {
            newBuildingFeaturesHtml += '<li>' + $(this).find('span').text() + '</li>';
        });

        buildingFeatures.empty().append('<div class="editorBlock">' +
            '<ul>' +
            newBuildingFeaturesHtml +
            '</ul>' +
            '</div>'
        );

        html2canvas($('body .main'), {
            dpi: window.devicePixelRatio,
            scale: 1,
            useCORS: true,
            onrendered: function (canvas) {
                var a4Width = 595.28;
                var border = 10;
                var imgWidth = a4Width;
                var imgHeight = (a4Width) / canvas.width * canvas.height;
                var img = canvas.toDataURL('image/png', 1.0);
                var pdf = new jsPDF('', 'pt', [imgWidth, imgHeight]);

                pdf.addImage(img, 'PNG', border, border, imgWidth - (border * 2), imgHeight - (border * 2));
                pdf.save(document.title + '.pdf');

                exportPDF.css('pointer-events', '');

                buildingFeatures.empty().append(originBuildingFeaturesHtml);

                $('body .social').show();
            }
        });
    });
});

$(function () {
    $('body')
        .on('click', '.dockingContact, .quickLink, .formAsk', function (e) {
            e.preventDefault();

            $('body').addClass('openPopup');
        })
        .on('click', '[data-id="close-popup"], .overlay', function () {
            $('body').removeClass('openPopup');
        })
        .on('click', '#questionForm .submit-button', function () {
            $(this).prop('disabled', true);

            $('#questionForm').submit();
        })
        .on('click', '#questionForm .reset-button', function () {
            var form = $('#questionForm');

            form.find('input[type=text], input[type=email], textarea').val('');

            form.find('select').val('').trigger('change');
        });
});
